import { ShieldAlert } from "lucide-react";
import { BOUNDARIES, SOURCES } from "./data";
import { Reveal, SectionHead } from "./Primitives";

export const Boundaries = () => (
  <section data-testid="boundaries-section" className="relative py-24 md:py-32 bg-[var(--surface-2)]">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHead eyebrow="Honest boundaries" title="What it is not — stated up front." body="Reference distance is not mutation impact, pathogenicity or drug sensitivity. We'd rather you know exactly where the edges are." />
      <div className="mt-16 grid md:grid-cols-2 gap-4">
        {BOUNDARIES.map((b, i) => (
          <Reveal key={b.t} delay={i * 0.06}>
            <div data-testid={`boundary-${i}`} className="h-full rounded-xl border border-[var(--line)] bg-[var(--surface)] p-8 flex gap-5">
              <ShieldAlert className="h-6 w-6 shrink-0 text-[var(--amber)]" />
              <div>
                <h3 className="font-display text-2xl font-bold tracking-tight">{b.t}</h3>
                <p className="mt-3 text-[var(--muted)] leading-relaxed">{b.d}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-4">
        <div data-testid="void-shell-status" className="rounded-xl border border-amber-300 bg-amber-50 dark:border-amber-400/30 dark:bg-amber-400/[0.04] p-8 grid md:grid-cols-[auto_1fr] gap-6 items-center">
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--amber)]">Void Shell · experimental</span>
          <p className="text-[var(--muted)] leading-relaxed">Its positive biological reference checks have not passed (TP53 and KRAS positives failed; the KRAS negative control passed). Results should not guide a chemist as validated binding-site findings.</p>
        </div>
      </Reveal>

      <div className="mt-28">
        <Reveal><p className="font-mono text-xs uppercase tracking-[0.22em] text-[var(--teal)]">Scientific sources</p></Reveal>
        <div className="mt-8 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 border-t border-l border-[var(--line)]">
          {SOURCES.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.04} className="border-r border-b border-[var(--line)] bg-[var(--surface)]">
              <div data-testid={`source-${i}`} className="group h-full p-5 hover:bg-[var(--ink)] transition-colors">
                <p className="font-display text-lg font-bold group-hover:text-[var(--teal)] transition-colors">{s.n}</p>
                <p className="mt-2 text-xs text-[var(--muted)] leading-relaxed">{s.r}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
